import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { PagedResponse } from "../models/paged-response";

const MAX_SUGGESTIONS = 10;

@Injectable({
    providedIn: "root"
})
export class AutocompleteService {
    constructor(private http: HttpClient) {}

    search(
        url: string,
        search: string,
        valueField: string,
        labelField: string
    ) {
        return this.http
            .get<PagedResponse<any>>(
                `${url}?search=${search}&start=0&length=${MAX_SUGGESTIONS}&summary=${valueField},${labelField}`
            )
            .pipe(map(resp => resp.data));
    }

    findByIds(url: string, ids: string) {
        return this.http
            .get<PagedResponse<any>>(`${url}?ids=${ids}`)
            .pipe(map(resp => resp.data));
    }
}
